import { Meilisearch } from "meilisearch";

const client = new Meilisearch({
  host: "https://ms.crm.iotd.ru/",
  apiKey: "vSBE1NxzvFMKBu1RwvrcbAylYygoQnsLN6330t_-dic",
});

async function searchMessages(text) {
  return await client.index("messages").search(text, {
    limit: 500,
  });
}
async function searchContacts(text) {
  return await client.index("contacts").search(text, {
    limit: 500,
  });
}
export default { searchMessages, searchContacts };
